import UsefulComponent from "components/useful";
import React from "react";
import "../../styles/useful.css"

const UsefulPage = () => {
  const usefulJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Полезная информация",
    "description": "Подборка полезных советов и информации для клиентов компании Пак Пакыч",
    "url": window.location.href
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(usefulJsonLd) }}
      />
      <main id='usefulPage'>
        <section className='section-useful usefulPage'>
          <div className='usefulPage-wrap'>
              <UsefulComponent />
          </div>
        </section>
      </main>
    </>
  );
};

export default UsefulPage;
